import {get, post} from '@/utils/request'

const SERVICE_URL = '/quotation-service/v1'

/** 询价包 */
export function fetchRFQList(params) {
    console.log('fetchRFQList')
    return post(SERVICE_URL + '/quotation/listRfq', params)
}
export function getRFQDetail(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getById', params, pathParam)
}
export function createRFQ(params) {
    return post(SERVICE_URL + '/quotation/insert', params)
}
export function editRFQ(params) {
    return post(SERVICE_URL + '/quotation/update', params)
}
export function deleteRFQ(params, pathParam) {
    return get(SERVICE_URL + '/quotation/delete', params, pathParam)
}
export function createMPRFQ(params) {
    return post(SERVICE_URL + '/quotation/createMPRfq', params)
}
/** 零件列表 */
export function getRfqPartList(params) {
    return post(SERVICE_URL + '/part/list', params)
}

export function listPartCompare(params) {
    return post(SERVICE_URL + '/part/listPartCompare', params)
}

/** 零件列表 */
export function getRfqPartViewList(params) {
    return post(SERVICE_URL + '/partView/list', params)
}

/** 零件列表 */
export function getSupplierSummaryList(params) {
    return post(SERVICE_URL + '/supplierSummaryView/list', params)
}

/** 获取比较信息页中当前轮次对比数据，包括不是当前轮次的最终报价数据 */
export function queryCurrentRoundAndLastList(params) {
    return post(SERVICE_URL + '/supplierSummaryView/queryCurrentRoundAndLastList', params)
}

/** 供应商管理 */
export function getRfqSupplierList(params) {
    return post(SERVICE_URL + '/rfqSupplier/list', params)
}

/** 供应商管理 */
export function getRfqSupplierListB(params) {
    return post(SERVICE_URL + '/rfqSupplier/listB', params)
}

export function deleteRfqSupplier(params, pathParam) {
    return get(SERVICE_URL + '/rfqSupplier/delete', params, pathParam)
}

export function getRfqSupplierById(params, pathParam) {
    return get(SERVICE_URL + '/rfqSupplier/getById', params, pathParam)
}

export function getRfqSupplierByUserId(params, pathParam) {
    return get(SERVICE_URL + '/rfqSupplier/getByUserId', params, pathParam)
}

export function createRfqSupplier(params) {
    return post(SERVICE_URL + '/rfqSupplier/add', params)
}

export function createRfqSupplierBatch(params) {
    return post(SERVICE_URL + '/rfqSupplier/addBatch', params)
}

export function editRfqSupplier(params) {
    return post(SERVICE_URL + '/rfqSupplier/edit', params)
}

export function editRfqSupplierList(params) {
    return post(SERVICE_URL + '/rfqSupplier/editBatch', params)
}

/** 根据rfq和供应商获取rfq关联供应商信息 */
export function getRfqSupplierByRfqIdAndVenderId(params) {
    return get(SERVICE_URL + '/rfqSupplier/getRfqSupplierByRfqIdAndVenderId', params)
}

/**修改报价**/
export function editRfqPartPriceList(params) {
    return post(SERVICE_URL + '/quotation/editRfqPartPriceList', params)
}

/** 零件列审批表 */
export function getApplierSummaryAuditList(params) {
    return post(SERVICE_URL + '/supplierSummaryAuditView/list', params)
}

/** 零件列审批表 */
export function getRfqPartAuditViewList(params) {
    return post(SERVICE_URL + '/partAuditView/list', params)
}
